/* eslint-disable import/prefer-default-export */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import {
  generateLinkForWava,
  updatePaymentMethodsWithLinks,
  hasWavaMethods
} from '../../../../services/paymentMethodsService';
import { usePaymentGatewayConnections } from '../../Payments/hooks/usePaymentGatewayConnections';

export const useSendPdfWithPaymentLinks = ({ order, onClose, onSendPdf }) => {
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [saving, setSaving] = useState(false);

  const { serializedPaymentMethods } = usePaymentGatewayConnections({ order });

  useEffect(() => {
    setPaymentMethods(serializedPaymentMethods);
  }, [serializedPaymentMethods]);

  const selectedPaymentMethods = paymentMethods.filter((p) => p.selected);
  const formattedDateTime = moment().local().locale('es').format('DD-MM-YYYY HH:mm');

  const toggleMethod = (methodKey) => {
    setPaymentMethods((prev) => prev.map((m) => (m.key === methodKey ? { ...m, selected: !m.selected } : m)));
  };

  const handleSendPdf = async () => {
    setSaving(true);

    try {
      let wavaLink = null;

      // Si hay métodos de Wava seleccionados, generar el link real
      if (hasWavaMethods(selectedPaymentMethods) && order) {
        wavaLink = await generateLinkForWava(order, retailer_info.id);
      }

      // Actualizar los métodos con los links reales
      const updatedPaymentMethods = updatePaymentMethodsWithLinks(
        selectedPaymentMethods,
        wavaLink,
        order
      );

      if (onSendPdf) {
        onSendPdf(updatedPaymentMethods, formattedDateTime, order);
      }
      if (onClose) {
        onClose();
      }
    } catch (err) {
      console.error('Error generating payment links for PDF:', err);
    } finally {
      setSaving(false);
    }
  };

  return {
    paymentMethods,
    toggleMethod,
    handleSendPdf,
    saving,
    selectedPaymentMethods
  };
};
